module.exports = __webpack_public_path__ + "img/vertical_3_5_3009.25965016.png";